import React from 'react';
import AppBar from '../../commons/AppBar'
import SpecificComponent from '../../commons/SpecificComponent';
import { Button, Grid, FormControl, InputLabel, Select, Input, MenuItem, Divider, Table, TableHead, TableRow, TableCell, TableBody, Switch } from '@material-ui/core';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import avatar from '../../Pics/avatar.jpg'
import LocalStorage from '../../providers/LocalStorage';
import ButtonsModules from '../../commons/ButtonsModules'
import AlertDialog from '../../commons/dialogs/AlertDialog';
// import Chart from 'react-google-charts'
import { Bar, Chart, HorizontalBar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels'
import AnalizeClienti from './Analize';
import FromServer from './FromServer';
import ImportaFisierDialog from '../../commons/dialogs/ImportaFisierDialog';
import IstoricFinanciar from '../../commons/dialogs/IstoricFinanciar';
import IstoricIndicatoriFinanciari from './IstoricIndicatoriFinanciari';
import { TopButtons } from '../../commons/TopButtons';
import InsertBilantBalanta from '../../commons/dialogs/InsertBilantBalanta';
import Planificare from './Planificare';
import ParametruBilant from './ParametruBilant';
import RapoarteProiect from '../projects/RapoarteProiect';
import Models from './Models';

export default class FinanciarContabil extends SpecificComponent {
    constructor(props) {
        super(props);
        this.child = React.createRef()
        this.state = {
            isOpenIBilant: false,
            isFurnizorButton: false,
            isSelectFisierFurnizori: false,
            isOpenIBalanta: false,
            idBilant: '',
            luna: '',
            textPopup:'',
            isPopSucces:true,
            nrYear: new Date().getFullYear(),
            listYears: new Utils().getLast10Years(),
            listMonths: new Utils().getMonths,
            isBilantButton: true,
            isSelectYear: false,
            isSelectLuna: false,
            isSelectFisierBilant: false,
            isSelectFisierBalanta: false,
            isBilant: false,
            isBalanta: false,
            isPopUp: false,
            listFise: [],
            listBalanta: [],
            isOpenAlert: false,
            choseDate: new Date(),
            isLunar: false,
            fisier: {},
            chartData: [],
            listRaport: [],
            chartData2: null,
            listSold: { Clienti: {}, Furnizori: {} },
            listCapitole: [],
            strCont: '',
            strTip: 'Venituri',
            listaConturi: new Models().listaConturi.filter(t => t.tip === 'Venituri')[0].conturi,
            listTipuri: ['Venituri', 'Cheltuieli'],
            listFull: [],
            chartProiecte: [],
            isSelectFisierClienti: false,
            isClienti: false,
            listIndicatori: [],
            listIstoric: [],
            nrIndicator: 1,
            possibleOutcome: null,
            isOpenFisier: false,
            isOpenIstoric: false,
            buttonSelectat: '', //analiza_financiara
            proiectId: '',
            topButtons: [{ id: 'arf', label: 'Analiza si raportare financiara (ARF)', color: '#900DCB' },

            { id: 'acf', label: 'Analiza cash flow (ACF)', color: '#C8C779' },
            { id: 'avc', label: 'Analiza de vanzari si clienti (AVC)', color: '#59D862' },
            { id: 'arp', label: 'Analiza si raportare proiecte (ARP)', color: '#3BCDFE' },
            { id: 'ars', label: 'Analiza si raportare stocuri (ARS)', color: '#FF9A35' },
            { id: 'importuri_date', label: 'Importuri Date', color: '#097BED' },
            { id: 'maimult', label: 'Mai mult', color: 'rgb(235, 9, 237)' },],
            isOpenAlertBalanta:false
        }
  
    }

    componentDidMount() {
        this.getFiseBilant()
        this.evaluareFinanciara()
        Chart.plugins.unregister(ChartDataLabels);
        this.goToDetaliiBilant()

        this.getIndicatori()
    }

    getIndicatori = async () => {

        let fs = new FromServer();


        let getData = await fs.getIndicatoriFinanciar(this.state.nrIndicator)


        if (getData.r) {

            this.setState({
                listIndicatori: getData.c.listIndicatori,
                listIstoric: getData.c.listIstoric,
                possibleOutcome: getData.c.possibleOutcome
            })

        }

    }


    insertBalanta = async () => {

        let fs = new FromServer();



        let insertBalanta = await fs.insertBalanta({
            an: this.state.nrYear,
            luna: 12
        })

        if (insertBalanta.r) {


            this.setState({ buttonSelectat: 'istoric' }, () => {

                this.openBalanta(insertBalanta.c[0])
            })

        }
    }

    insertBilant = async () => {

        let fs = new FromServer();

        let insertBilant = await fs.insertBilant({
            an: this.state.nrYear,
            luna: 12
        })

        if (insertBilant.r) {

            this.setState({ buttonSelectat: 'istoric' }, () => {

                this.openBilant(insertBilant.c[0])
            })
        }
    }



    onIndicatorSelect = async (ev) => {

        let fs = new FromServer();


        let getData = await fs.getIndicatoriFinanciar(ev.target.value)

        if (getData.r) {

            this.setState({
                listIstoric: getData.c.listIstoric,
                nrIndicator: ev.target.value,
                possibleOutcome: getData.c.possibleOutcome
            })
        }



    }



    evaluareFinanciara = async () => {


        let fs = new FromServer();

        let getData = await fs.getEvaluare()

        // console.log('chartData2 :', chartData2);

        // console.log('chartData2 :', chartData2);

        // console.warn('listCapitole :', getData);

        if (getData.r) {
            this.setState({
                chartData: getData.c.chartData,
                listCapitole: getData.c.listCapitole,
                chartProiecte: getData.c.chartProiecte,
                listFull: getData.c.listFull,
                listRaport: getData.c.listRaport,
                chartData2: getData.c.chartData2,
                listSold: getData.c.listSold
            })
        }


    }

    furnizorClick = () => {

        this.setState({
            isClientiButton: false,
            isBilantButton: false,
            isFurnizorButton: true,
            isSelectYear: true,
            isClienti: false,
            isBalanta: false,
            isBilant: false
        })
    }



    bilantClick = () => {
        this.setState({
            isBilantButton: false,
            isClientiButton: false,
            isFurnizorButton: false,
            isSelectYear: true,
            isBilant: true,
            isBalanta: false,
        })
    }

    balantaClick = () => {
        this.setState({
            isClientiButton: false,
            isBilantButton: false,
            isFurnizorButton: false,
            isSelectYear: true,
            isBalanta: true,
            isBilant: false
        })
    }


    clientiClick = () => {
        this.setState({
            isClientiButton: false,
            isBilantButton: false,
            isFurnizorButton: false,
            isSelectYear: true,
            isClienti: true,
            isBalanta: false,
            isBilant: false
        })
    }


    getFiseBilant = async () => {

        let fs = new FromServer();

        let getFise = await fs.getFiseBilant()


        if (getFise.r) {
            // console.log('getFise :', f);
            this.setState({
                listFise: getFise.c.listFise,
                listBalanta: getFise.c.listBalanta
            })
        }
    }

    // testFunc = async()=>{
    //     let ws = new Ws()

    //     let getData = await ws.getData('Bilant/Profilograma', {idHead:12})

    //     console.log('getData :', getData);
    // }

    onYearSelect = async (ev) => {

        // console.log('ev :', ev);
        let ws = new Ws();

        if (this.state.isBilant) {



            let countFisiere = await ws.customSelect(`select * from fin_import_bilant_head where an= @p1 and isnull(sters,0) != 1`, {
                p1: ev.target.value
            })

            // console.log('countFisiere :', countFisiere);

            if (countFisiere.Succes) {
                let fisier = countFisiere.Content

                if (fisier.length > 0) {
                    this.setState({
                        fisier: fisier[0],
                        isOpenAlert: true,
                        nrYear: ev.target.value,
                        isBilantButton: true,
                    })
                } else {
                    this.setState({
                        nrYear: ev.target.value,
                        isSelectYear: false,
                        isBilantButton: true,


                    }, () => {
                        this.selectFile('import-bilant')
                    })
                }
            }




        } else if (this.state.isClienti) {
            let ws = new Ws();




            this.setState({
                nrYear: ev.target.value,
                isSelectYear: false,
                isSelectLuna: true,


            }, () => {

            })

        }
        else if (this.state.isFurnizorButton) {
            this.setState({
                nrYear: ev.target.value,
                isSelectYear: false,
                isSelectLuna: true,


            }, () => {

            })
        }


        else {

            let countFisiere = await ws.customSelect(`select * from fin_import_balanta_lunara_head where an= @p1 and isnull(sters,0) != 1`, {
                p1: ev.target.value
            })

            if(countFisiere.Succes){
                let fisier = countFisiere.Content

                if(fisier.length > 0){
                    this.setState({
                        fisier:fisier[0],
                        isOpenAlertBalanta:true,
                        nrYear:ev.target.value,
                        isBalantaButton:true
                    })
                }else{
                    this.setState({
                        nrYear: ev.target.value,
                        isSelectYear: false,
                        isBilantButton: true,
        
                    }, () => {
                        this.selectFile('import-balanta')
                    })

                }
            }

            


        }

    }

    onMonthSelect = (ev) => {

        if (this.state.isClienti) {
            // console.log('onMonthSelect :');
            // console.log('ev.target.value :', ev.target.value);
            this.setState({
                luna: ev.target.value,
                isSelectLuna: false,
                isSelectFisierClienti: true,
                isBilantButton: true,
            })
            this.selectFile('import-clienti')

        } else if (this.state.isFurnizorButton) {
            // console.log('onMonthSelect :');
            // console.log('ev.target.value :', ev.target.value);
            this.setState({
                luna: ev.target.value,
                isSelectLuna: false,
                isSelectFisierFurnizori: true,
                isBilantButton: true,
            })
            this.selectFile('import-furnizori')
        }


    }



    selectFile = (id) => {
        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()
    }

    importFurnizor = (id) => {
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        // console.log('import furnizori :');

        // console.log('this.state.luna :', this.state.luna);


        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadClient('Balanta/ImportRaportFurnizoriLunar', saveFile, this.state.nrYear, this.state.luna);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                this.setState({
                    isPopUp: true,
                    isPopSucces:true,
                    textPopup:'Succes import'
                }, () => {
                    this.evaluareFinanciara()
                    setTimeout(() => {
                        this.setState({
                            isPopUp: false,
                            isBilantButton: true,
                            isClientiButton: true,
                            isSelectYear: false,
                            isSelectLuna: false,
                            isSelectFisierBilant: false,
                            isSelectFisierBalanta: false,
                            isSelectFisierClienti: false,
                            isClienti: false,

                            isBilant: false,
                            isBalanta: false,
                        })
                    }, 3000)
                })
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }


    importClienti = (id) => {
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);


        // console.log('this.state.luna :', this.state.luna);


        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadClient('Balanta/ImportRaportClientiLunar', saveFile, this.state.nrYear, this.state.luna);

            console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                this.setState({
                    isPopUp: true,
                    isPopSucces:true,
                    textPopup:'Succes import'
                }, () => {
                    this.evaluareFinanciara()
                    setTimeout(() => {
                        this.setState({
                            isPopUp: false,
                            isBilantButton: true,
                            isClientiButton: true,
                            isSelectYear: false,
                            isSelectLuna: false,
                            isSelectFisierBilant: false,
                            isSelectFisierBalanta: false,
                            isSelectFisierClienti: false,
                            isClienti: false,

                            isBilant: false,
                            isBalanta: false,
                        })
                    }, 3000)
                })
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }
    }

    importBilant = (id) => {

        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);





        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadbilant('Bilant/ImportBilant', saveFile, this.state.nrYear);

            console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                this.setState({
                    isPopUp: true,
                    isPopSucces:true,
                    textPopup:'Succes import'
                }, () => {
                    this.evaluareFinanciara()
                    setTimeout(() => {
                        this.setState({
                            isPopUp: false,
                            isBilantButton: true,
                            isSelectYear: false,
                            isSelectLuna: false,
                            isSelectFisierBilant: false,
                            isSelectFisierBalanta: false,
                            isBilant: false,
                            isBalanta: false,
                        })
                    }, 3000)
                })
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }

    importBalanta = (id) => {

        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);



        // console.warn('importBalanta :');

        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let fs = new FromServer();


            let update = await fs.importBalantaLunaraHead({ sters: 1 }, { an: this.state.nrYear })
            if (update.r) {
                let uploadImage = await ws.uploadbalanta('Balanta/ImportBalantaMicroAnuala', saveFile, this.state.nrYear);

                // console.log('uploadImage :', uploadImage);
                if (uploadImage.Succes) {
                    this.setState({
                        isPopUp: true,
                        isPopSucces:true,
                        textPopup:'Succes import'
                    }, () => {

                        this.evaluareFinanciara()
                        setTimeout(() => {
                            this.setState({
                                isPopUp: false,
                                isBilantButton: true,
                                isSelectYear: false,
                                isSelectLuna: false,
                                isSelectFisierBilant: false,
                                isSelectFisierBalanta: false,
                                isBilant: false,
                                isBalanta: false,
                            })
                        }, 3000)
                    })
                }else{
                    this.setState({
                        isPopUp: true,
                        isPopSucces:false,
                        textPopup:`Balanta nu a putut fi importata va rugam verificati formatul fisierului de import, mai ales campurile de debit si credit. 
                                    Acestea trebuie sa fie in format numeric.`
                    })
                }

            }


            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }


    goToBilant = (f) => {
        this.props.history.push(`/parametrubilant/${f.id}`)
    }

    goToDetaliiBilant = async () => {
        let fs = new FromServer();


        let getBilant = await fs.getDetaliiBilant()

        // console.log('getBilant :', getBilant);

        if (getBilant.r) {
            this.setState({ idBilant: getBilant.c[0] ? getBilant.c[0].id : '' })
        }
    }


    updateBilant = async () => {


        let fs = new FromServer();

        let update = await fs.updateBilant({ sters: 1 }, { an: this.state.nrYear })

        if (update.r) {
            this.setState({ isOpenAlert: false }, () => {
                this.selectFile('import-bilant')
            })
        }
    }

    updateBalanta = async () =>{
        let fs = new FromServer();

        let update= await fs.updateBalanta({sters:1},{an:this.state.nrYear})

        if(update.r){
            this.setState({isOpenAlertBalanta:false},()=>{
                this.selectFile('import-balanta')
            })
        }
    }

    colorSwitch = (label) => {

        switch (label) {
            case this.dictionary.financiarContabil.stationara:
                return '#6262d6';
            case this.dictionary.financiarContabil.negativa:
                return '#ea1515';
            case this.dictionary.financiarContabil.pozitiva:
                return '#1ab91a';
            default:
                return 'gray'
        }


    }


    lunarSapt = (ev) => {

        let fs = new FromServer()

        let cloneList = [...this.state.listFull]

        let date;

        if (this.state.isLunar) {
            date = new Date().setMonth(new Date().getMonth() - 1)




        } else {
            date = new Date().setDate(new Date().getDate() - 7)
        }
        // console.log('date :', new Date(date));

        cloneList = cloneList.filter(c => new Date(c.dataora_propusa) > new Date(date))



        let userIds = cloneList.map(l => l.id_utilizator_responsabil)


        let userRez = []

        let users = [...new Set(userIds)]




        // console.log('users :', users);


        let counter = users.length


        for (let i = 0; i < counter; i++) {
            userRez.push(fs.userAnalize1(users[i], cloneList))
        }


        let counter3 = userRez.length

        let chartData2 =
            {
                chartData: [],

                labels: [this.dictionary.financiarContabil.totalOreCumulateTaskuri,
                this.dictionary.financiarContabil.totalOreDepasiteCompletare,
                this.dictionary.financiarContabil.totalOreAvansCompletare,
                this.dictionary.financiarContabil.procentajDepasire,
                this.dictionary.financiarContabil.procentajAvans
                ]

            }
        for (let i = 0; i < counter3; i++) {


            // chartData2.push([
            //     userRez[i].numeUser,
            //     userRez[i].totalOreCumulateTaskuri,
            //     userRez[i].totalOreDiferentaCompletare > 0 ? Math.abs(userRez[i].totalOreDiferentaCompletare) : 0,
            //     userRez[i].totalOreDiferentaCompletare < 0 ? Math.abs(userRez[i].totalOreDiferentaCompletare) : 0,
            //     userRez[i].pctDepasire > 0 ? Math.abs(userRez[i].pctDepasire) : 0,
            //     userRez[i].pctDepasire < 0 ? Math.abs(userRez[i].pctDepasire) : 0,
            // ])
            chartData2.chartData.push({

                user: userRez[i].numeUser, chartData: [

                    { label: this.dictionary.financiarContabil.totalOreCumulateTaskuri, value: userRez[i].totalOreCumulateTaskuri },
                    { label: this.dictionary.financiarContabil.totalOreDepasiteCompletare, value: userRez[i].totalOreDiferentaCompletare > 0 ? Math.abs(userRez[i].totalOreDiferentaCompletare) : 0 },
                    { label: this.dictionary.financiarContabil.totalOreAvansCompletare, value: userRez[i].totalOreDiferentaCompletare < 0 ? Math.abs(userRez[i].totalOreDiferentaCompletare) : 0 },
                    { label: this.dictionary.financiarContabil.procentajDepasire, value: userRez[i].pctDepasire > 0 ? Math.abs(userRez[i].pctDepasire) : 0 },
                    { label: this.dictionary.financiarContabil.procentajAvans, value: userRez[i].pctDepasire < 0 ? Math.abs(userRez[i].pctDepasire) : 0 }
                ]

            })
        }



        this.setState({
            isLunar: ev.target.checked,
            listRaport: userRez
        })

    }


    chartMapping = (c) => {
        let count = c.length

        let dataSet = []

        for (let i = 0; i < count; i++) {
            let chdata = c[i].map((ch, idx) => {
                dataSet.push(
                    {
                        label: c.user,
                        backgroundColor: new Utils().culoriCharts(idx),
                        hoverBackgroundColor: new Utils().culoriCharts(idx),
                        data: [ch.value]

                    }
                )
            })
        }

        // console.log('dataSet :', dataSet);

        return dataSet
    }



    buttonSelected = async (id) => {

        let fs = new FromServer()

        if (id === 'importuri_date') {
            this.setState({
                isOpenFisier: true,
                buttonSelectat: id
            })
        } else if (id === 'maimult') {
            let getBilant = await fs.getDetaliiBilant()

            if (getBilant.r) {
                this.props.history.push(`/maimult/${getBilant.c[0].id}`)
            }
        }

        else {
            this.setState({ buttonSelectat: id })
            this.props.history.push(`/${id}`)
        }



    }


    changeProiecte = (ev) => {
        // console.log('ev.target.value :', ev.target.value);

        this.setState({ proiectId: ev.target.value }, () => {
            this.changeProiect(ev.target.value)
        })
    }

    changeTip = (ev) => {
        this.setState({
            strTip: ev.target.value,
            listaConturi: new Models().listaConturi.filter(t => t.tip === ev.target.value)[0].conturi
        })
    }

    comparatieIndividualaRealizatPrognozat = async () => {
        // console.log('this.state.strCont :', this.state.strCont);

        let ws = new Ws();

        let comparatie = await ws.getData('EvaluareFinanciara/ComparatieIndividualaContRealizatPrognozat', { an: 2019, cont: this.state.strCont })


        // console.log('comparatie :', comparatie);
    }

    render() {
        return (
            <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />

                <AlertDialog
                    open={this.state.isOpenAlert}
                    limba={this.dictionary}
                    dialogClose={() => {
                        this.setState({
                            isBilantButton: true,
                            isSelectYear: false,
                            isSelectLuna: false,
                            isSelectFisierBilant: false,
                            isSelectFisierBalanta: false,
                            isBilant: false,
                            isBalanta: false,
                            isOpenAlert: false
                        })
                    }}

                    title={this.dictionary.financiarContabil.alertExistaBilant}
                    yesFunction={this.updateBilant}
                />

                <AlertDialog
                    open={this.state.isOpenAlertBalanta}
                    limba={this.dictionary}
                    dialogClose={() => {
                        this.setState({
                            isBilantButton: true,
                            isSelectYear: false,
                            isSelectLuna: false,
                            isSelectFisierBilant: false,
                            isSelectFisierBalanta: false,
                            isBilant: false,
                            isBalanta: false,
                            isOpenAlertBalanta: false
                        })
                    }}

                    title={"Balanta pentru anul selectat deja exista, doriti sa o inlocuiti ?"}
                    yesFunction={this.updateBalanta}
                />



                <InsertBilantBalanta
                    open={this.state.isOpenIBalanta}
                    dialogClose={() => { this.setState({ isOpenIBalanta: false }) }}
                    strNume={'Adauga Balanta'}
                    nrYear={this.state.nrYear}
                    changeYear={(ev) => { this.setState({ nrYear: ev.target.value }) }}
                    listYears={this.state.listYears}
                    luna={12}
                    changeLuna={(ev) => { this.setState({ luna: ev.target.value }) }}
                    listMonths={this.state.listMonths}
                    addBilantBalanta={this.insertBalanta}
                    limba={this.dictionary}
                />

                <InsertBilantBalanta
                    open={this.state.isOpenIBilant}
                    dialogClose={() => { this.setState({ isOpenIBilant: false }) }}
                    strNume={'Adauga Bilant'}
                    nrYear={this.state.nrYear}
                    changeYear={(ev) => { this.setState({ nrYear: ev.target.value }) }}
                    listYears={this.state.listYears}
                    luna={12}
                    changeLuna={(ev) => { this.setState({ luna: ev.target.value }) }}
                    listMonths={this.state.listMonths}
                    addBilantBalanta={this.insertBilant}
                    limba={this.dictionary}
                />

                <ImportaFisierDialog
                    open={this.state.isOpenFisier}
                    creeazaBilantManual={() => { this.setState({ isOpenIBilant: true }) }}
                    creeazaBalantaManual={() => { this.setState({ isOpenIBalanta: true }) }}
                    dialogClose={() => {
                        this.setState({
                            isOpenFisier: false, isPopUp: false,
                            isBilantButton: true,
                            isSelectYear: false,
                            isSelectLuna: false,
                            isSelectFisierBilant: false,
                            isSelectFisierBalanta: false,
                            isSelectFisierFurnizori: false,
                            isFurnizorButton: false,
                            isBilant: false,
                            isBalanta: false,
                        })
                    }}
                    isFurnizorButton={this.state.isFurnizorButton}
                    isSelectFisierFurnizori={this.state.isSelectFisierFurnizori}
                    isBilantButton={this.state.isBilantButton}
                    furnizorClick={this.furnizorClick}
                    bilantClick={this.bilantClick}
                    balantaClick={this.balantaClick}
                    clientiClick={this.clientiClick}
                    dictionary={this.dictionary}
                    isSelectYear={this.state.isSelectYear}
                    nrYear={this.state.nrYear}
                    onYearSelect={this.onYearSelect}
                    listYears={this.state.listYears}
                    isSelectLuna={this.state.isSelectLuna}
                    luna={this.state.luna}
                    onMonthSelect={this.onMonthSelect}
                    listMonths={this.state.listMonths}
                    isSelectFisierBilant={this.state.isSelectFisierBilant}
                    selectFile={this.selectFile}
                    importBilant={this.importBilant}
                    isSelectFisierBalanta={this.state.isSelectFisierBalanta}
                    importFurnizor={this.importFurnizor}
                    importBalanta={this.importBalanta}
                    importClienti={this.importClienti}
                    textPopup={this.state.textPopup}
                    isPopUp={this.state.isPopUp}
                    history={this.props.history}
                    isPopSucces={this.state.isPopSucces}
                    biletOridin={()=>{this.props.history.push('/bileteordin')}}
                />
                {/* <IstoricFinanciar
                        open={this.state.isOpenIstoric}
                        dialogClose={()=>{this.setState({isOpenIstoric:false})}}
                        history={this.props.history}
                        dictionary={this.dictionary}
                        /> */}

                <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />


                <Divider className="pm-divider" />

                <div className='container' style={{ position: 'relative', }} >



                    {this.state.topButtons.map((b, idx) => {

                        if (idx <= 2) {
                            return (
                                <div key={idx} style={{ width: 'fit-content', marginTop: 10, justifyContent: 'center', display: 'inline-block' }} className="loginButton"  >
                                    {/* <Button onClick={this.bilantClick} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaBilant}</Button>
                                <Button onClick={this.balantaClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaBalanta}</Button>
                                <Button onClick={this.clientiClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaClienti}</Button>
                            */}


                                    <TopButtons
                                        b={b}
                                        buttonSelected={this.buttonSelected}
                                        buttonSelectat={this.state.buttonSelectat}
                                    />





                                </div>
                            )
                        }



                    })}
                </div>

                <div className='container' style={{ position: 'relative', }} >



                    {this.state.topButtons.map((b, idx) => {

                        if (idx > 2) {
                            return (
                                <div key={idx} style={{ width: 'fit-content', marginTop: 10, justifyContent: 'center', display: 'inline-block' }} className="loginButton"  >
                                    {/* <Button onClick={this.bilantClick} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaBilant}</Button>
            <Button onClick={this.balantaClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaBalanta}</Button>
            <Button onClick={this.clientiClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaClienti}</Button>
        */}


                                    <TopButtons
                                        b={b}
                                        buttonSelected={this.buttonSelected}
                                        buttonSelectat={this.state.buttonSelectat}
                                    />





                                </div>
                            )
                        }



                    })}
                </div>
                {/* <Button onClick={this.bilantClick} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaBilant}</Button>
                                    <Button onClick={this.balantaClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaBalanta}</Button>
                                    <Button onClick={this.clientiClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaClienti}</Button>
                                */}


                {/* <Button onClick={()=>{this.setState({isOpenFisier:true})}} style={{ width: 'fit-content', marginLeft: 10 }} 
                                                            className='pm-login-button' 
                                                            variant="outlined">Importa Fisier</Button> */}



                {/* <Grid style={{ width: 'fit-content', marginTop: 20 }} className="loginButton" item xs={12} sm={12} md={12} lg={12} xl={12} > */}
                {/* <Button onClick={() => { this.props.history.push('/istoricindicatiorifinanciari') }}
                            style={{
                                width: 'fit-content',
                                color: 'white',
                                backgroundColor: '#2cb7e0'
                            }} variant="contained">{this.dictionary.financiarContabil.istoricIndicatoriFinanciari}</Button>

                        <Button onClick={() => { this.props.history.push('/balantebilanturi') }}
                            style={{
                                width: 'fit-content',
                                color: 'white',
                                marginLeft: 10,
                                backgroundColor: '#2cb7e0'
                            }} variant="contained">{this.dictionary.financiarContabil.balanteSiBilanturi}</Button>

                        <Button onClick={() => { this.props.history.push('/planificare') }}
                            style={{
                                width: 'fit-content',
                                color: 'white',
                                marginLeft: 10,
                                backgroundColor: '#2cb7e0'
                            }} variant="contained">{this.dictionary.financiarContabil.planificare}</Button> */}
                {/* <Button onClick={() => { this.setState({isOpenIstoric:true})}}
                            style={{
                                width: 'fit-content',
                                color: 'white',
                                marginLeft: 10,
                                backgroundColor: '#2cb7e0'
                            }} variant="contained">Istoric</Button> */}

                {/* </Grid> */}

                {/* <Grid style={{ display: this.state.isSelectYear === true ? 'block' : 'none' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <FormControl className='inputFocus' style={{ width: '30%', marginTop: 20 }}>
                            <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.selecteazaAnul}</InputLabel>
                            <Select

                                value={this.state.nrYear || ""}
                                onChange={(ev) => { this.onYearSelect(ev) }}

                                input={<Input id="resursa" />}>


                                {this.state.listYears.map((s, idx) => {
                                    return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>


                    </Grid>

                    <Grid style={{ display: this.state.isSelectLuna === true ? 'block' : 'none' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <FormControl className='inputFocus' style={{ width: '30%', marginTop: 20 }}>
                            <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.selecteazaLuna}</InputLabel>
                            <Select

                                value={this.state.luna || ""}
                                onChange={(ev) => { this.onMonthSelect(ev) }}

                                input={<Input id="resursa" />}>


                                {this.state.listMonths.map((s, idx) => {
                                    return <MenuItem value={s.id} key={idx}  > {s.luna}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid style={{ width: 'fit-content', display: this.state.isSelectFisierBilant === true ? 'block' : 'none' }} className="loginButton" item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <Button onClick={() => { this.selectFile('import-bilant') }} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.selecteazaFisier}</Button>
                        <input id="import-bilant" type="file" accept="file/*"
                            onChange={() => { this.importBilant('import-bilant') }}
                            style={{ display: 'none' }}
                        ></input>
                    </Grid>

                    <Grid style={{ width: 'fit-content', display: this.state.isSelectFisierBalanta === true ? 'block' : 'none' }} className="loginButton" item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <Button onClick={() => { this.selectFile('import-balanta') }} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.selecteazaFisier}</Button>
                        <input id="import-balanta" type="file" accept="file/*"
                            onChange={() => { this.importBalanta('import-balanta') }}
                            style={{ display: 'none' }}
                        ></input>
                    </Grid>

                    <Grid style={{ width: 'fit-content', display: this.state.isSelectFisierClienti === true ? 'block' : 'none' }} className="loginButton" item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <Button onClick={() => { this.selectFile('import-clienti') }} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.selecteazaFisier}</Button>
                        <input id="import-clienti" type="file" accept="file/*"
                            onChange={() => { this.importClienti('import-clienti') }}
                            style={{ display: 'none' }}
                        ></input>
                    </Grid>
                    <div style={{
                        position: 'absolute',
                        zIndex: 5000,
                        bottom: -100,
                        left: 0,
                        display: this.state.isPopUp === true ? 'block' : 'none',
                        right: 0,
                        color: '#18d618',
                    }}>



                        <i style={{
                            fontSize: 60
                        }} className='material-icons'>thumb_up</i>
                        <br />

                        <span >{this.dictionary.financiarContabil.succesImportBilant}</span>

                    </div> */}




                {this.state.buttonSelectat === 'detalii' &&

                    <ParametruBilant idBilant={this.state.idBilant} />
                }


                {this.state.buttonSelectat === 'istoric' &&


                    <IstoricIndicatoriFinanciari openBalanta={c => this.openBalanta = c}
                        openBilant={b => this.openBilant = b}
                    />

                }

                {this.state.buttonSelectat === 'planificare' &&

                    <Planificare />
                }

                {this.state.buttonSelectat === 'analiza_financiara' &&
                    <div>
                        <div className='container'>
                            <h2 className='pm-title'>{this.dictionary.financiarContabil.analizaFinanciara}</h2>
                            <Grid style={{ marginBottom: 50 }} container>


                                <Grid style={{ border: '1px solid black' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                                    <h3> {this.dictionary.financiarContabil.solduriClienti}</h3>
                                    <p><b>{this.dictionary.financiarContabil.debit}: </b> {this.state.listSold.Clienti.Debit} lei</p>
                                    <p><b>{this.dictionary.financiarContabil.credit}:</b>  {this.state.listSold.Clienti.Credit} lei</p>
                                </Grid>

                                <Grid style={{ border: '1px solid black' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                                    <h3> {this.dictionary.financiarContabil.solduriFurnizori}</h3>
                                    <p><b>{this.dictionary.financiarContabil.debit}: </b>{this.state.listSold.Furnizori.Debit} lei</p>
                                    <p><b>{this.dictionary.financiarContabil.credit}:</b> {this.state.listSold.Furnizori.Credit} lei</p>
                                </Grid>



                            </Grid>
                        </div>


                        {this.state.listCapitole.length > 1 &&
                            <div >




                                {this.state.listCapitole.map((c, idx) => {
                                    return (
                                        <div key={idx}>
                                            <h1 className='pm-title'>{c.capitol}</h1>
                                            {c.categorii.map((cat, idx2) => {
                                                return (
                                                    <div key={`cat${idx2}`}>
                                                        <h3 className='pm-title'>{cat.categorie}</h3>
                                                        {cat.chartData.map((ch, idx3) => {
                                                            return (
                                                                <div style={{
                                                                    width: '45%', display: 'inline-block',
                                                                    position: 'relative',
                                                                    border: '1px dashed gray',
                                                                    padding: 10,
                                                                    marginRight: 20, marginTop: 30, verticalAlign: 'top'
                                                                }}
                                                                    key={`chart${idx3}`}
                                                                >
                                                                    <h4 style={{ marginBottom: 0 }} className='pm-title'>{ch.titlu}</h4>
                                                                    <Bar

                                                                        datasetKeyProvider={() => { return Math.random() }}
                                                                        // getElementAtEvent={(element)=>this.getLineData(element,i)}
                                                                        plugins={[ChartDataLabels]}

                                                                        data={{
                                                                            labels: ch.labels.map((r) => { return (r) }),
                                                                            datasets: [
                                                                                {
                                                                                    //    label:ch.chartData.map((r)=>{return(Number(r))}) ,
                                                                                    backgroundColor: ch.culori.map((r) => { return (r) }),
                                                                                    hoverBackgroundColor: ch.chartData.map((r) => { return (new Utils().culoriCharts(Number(r))) }),
                                                                                    data: ch.chartData.map((r) => { return (Number(r).toFixed(2)) }),

                                                                                },

                                                                            ],


                                                                        }}

                                                                        options={{

                                                                            onClick: function (evt, elements) {

                                                                                let selectedIndex = null
                                                                                if (elements && elements.length) {
                                                                                    var segment = elements[0];
                                                                                    this.update();
                                                                                    if (selectedIndex !== segment["_index"]) {
                                                                                        selectedIndex = segment["_index"];
                                                                                        segment._model.outerRadius += 20;
                                                                                    }
                                                                                    else {
                                                                                        selectedIndex = null;
                                                                                    }
                                                                                }
                                                                            },
                                                                            layout: {
                                                                                padding: 60,
                                                                                height: 300
                                                                            },

                                                                            plugins: {

                                                                                datalabels: {
                                                                                    color: 'black',
                                                                                    formatter: (value, context) => {
                                                                                        // console.log('value :', value);
                                                                                        //    console.log('context :', );

                                                                                        return value

                                                                                    },
                                                                                    font: {
                                                                                        size: 16,
                                                                                        weight: 600
                                                                                    },
                                                                                    align: 'end',
                                                                                    display: 'auto',
                                                                                    clamp: true


                                                                                },

                                                                            },
                                                                            legend: {
                                                                                display: false
                                                                            }
                                                                        }}

                                                                    />
                                                                    {/* <h5 className='pm-title'>{ch.help}</h5> */}
                                                                    <h6 className='pm-title'>{ch.help}</h6>
                                                                </div>


                                                            )
                                                        })}
                                                        <Divider style={{ marginTop: 50 }} className='pm-divider' />

                                                    </div>
                                                )
                                            })}

                                        </div>

                                    )
                                })}
                            </div>


                        }
                        <Grid className='container' container>

                            <Grid item xs={12} sm={12} md={3} lg={3} xl={3} >
                                <FormControl className='inputFocus' style={{ width: '90%', marginTop: 16 }}>
                                    <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.tip}</InputLabel>
                                    <Select

                                        value={this.state.strTip || ""}
                                        onChange={this.changeTip}

                                        input={<Input id="resursa" />}>


                                        {this.state.listTipuri.map((s, idx) => {
                                            return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                        })
                                        }
                                    </Select>
                                </FormControl>


                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={3} lg={3} xl={3} >

                                <FormControl className='inputFocus' style={{ width: '90%', marginTop: 16 }}>
                                    <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.cont}</InputLabel>
                                    <Select

                                        value={this.state.strCont || ""}
                                        onChange={(ev) => { this.setState({ strCont: ev.target.value }) }}

                                        input={<Input id="resursa" />}>


                                        {this.state.listaConturi.map((s, idx) => {
                                            return <MenuItem value={s.cont} key={idx}  > {s.cont}:{s.descriere}</MenuItem>

                                        })
                                        }
                                    </Select>
                                </FormControl>


                            </Grid>

                            <Button onClick={this.comparatieIndividualaRealizatPrognozat} style={{ width: 'fit-content', marginLeft: 10 }}
                                className='pm-login-button' variant="outlined">Comparatie Individuala Realizat Prognozat</Button>

                        </Grid>
                    </div>
                }




                <Divider className='pm-divider' />



                {this.state.chartData.length > 1 && this.state.buttonSelectat === 'analiza_financiara' &&
                    <div style={{ position: 'relative' }}>

                        <h1 style={{ fontWeight: 600 }} className='pm-title'>{this.dictionary.financiarContabil.prognoza}</h1>


                        {this.state.chartData.map((c, idx) => {
                            return (
                                <div style={{
                                    width: '45%', display: 'inline-block',
                                    position: 'relative',
                                    marginRight: 20,
                                    marginTop: 30,
                                    verticalAlign: 'top',
                                    border: '1px dashed gray'
                                }} key={idx}>

                                    <div style={{
                                        position: 'absolute', right: 5, zIndex: 5000, top: 5,
                                    }}>

                                        <div

                                            style={{
                                                display: 'inline-block',
                                                verticalAlign: 'middle',

                                                cursor: 'help',
                                                width: 85,
                                                height: 85,
                                                backgroundColor: this.colorSwitch(c.tipAnticipare),
                                                borderRadius: '50%'
                                            }}>
                                            <span className='pm-title' style={{ lineHeight: '80px', color: 'white', fontSize: 16 }}>{c.tipAnticipare}</span>
                                        </div>
                                    </div>
                                    <h3 style={{ marginBottom: 0 }} className='pm-title'>{c.titlu}</h3>
                                    <Bar

                                        datasetKeyProvider={() => { return Math.random() }}
                                        // getElementAtEvent={(element)=>this.getLineData(element,i)}
                                        plugins={[ChartDataLabels]}

                                        data={{
                                            labels: c.labels.map((r) => { return (r) }),
                                            datasets: [
                                                {
                                                    //    label:ch.chartData.map((r)=>{return(Number(r))}) ,
                                                    backgroundColor: c.tipAnticipare !== 'Pozitiva' ? ['rgb(26, 185, 26)', 'darkorange', 'red'] : ['red', 'darkorange', 'rgb(26, 185, 26)'],
                                                    hoverBackgroundColor: c.chartPrognoza.map((r) => { return (new Utils().culoriCharts(Number(r.toFixed(0)))) }),
                                                    data: c.chartPrognoza.map((r) => { return (Number(r.toFixed(2))) }),

                                                }
                                            ],


                                        }}

                                        options={{

                                            onClick: function (evt, elements) {

                                                let selectedIndex = null
                                                if (elements && elements.length) {
                                                    var segment = elements[0];
                                                    this.update();
                                                    if (selectedIndex !== segment["_index"]) {
                                                        selectedIndex = segment["_index"];
                                                        segment._model.outerRadius += 20;
                                                    }
                                                    else {
                                                        selectedIndex = null;
                                                    }
                                                }
                                            },
                                            layout: {
                                                padding: 60,
                                                height: 300
                                            },

                                            plugins: {

                                                datalabels: {
                                                    color: 'black',
                                                    formatter: (value, context) => {
                                                        // console.log('value :', value);
                                                        //    console.log('context :', );

                                                        return value

                                                    },
                                                    font: {
                                                        size: 16,
                                                        weight: 600
                                                    },
                                                    align: 'end',
                                                    display: 'auto',
                                                    clamp: true


                                                },

                                            },
                                            legend: {
                                                display: false
                                            }
                                        }}

                                    />




                                </div>
                            )
                        })}

                        <div className='container'>

                            <FormControl className='inputFocus' style={{ width: '30%', marginTop: 20 }}>
                                <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.selecteazaIndicator}</InputLabel>
                                <Select

                                    value={this.state.nrIndicator || ""}
                                    onChange={(ev) => { this.onIndicatorSelect(ev) }}

                                    input={<Input id="resursa" />}>


                                    {this.state.listIndicatori.map((s, idx) => {
                                        return <MenuItem value={s.id} key={idx}  > {s.simbol}</MenuItem>

                                    })
                                    }
                                </Select>
                            </FormControl>


                            {this.state.possibleOutcome !== null &&
                                <Grid container style={{ marginTop: 20 }}>
                                    <Grid style={{ width: '90%', border: '1px solid black' }} item xs={12} sm={12} md={6} lg={6} xl={6} >

                                        <h4 className='pm-title'>Ultimile valori introduse</h4>
                                        <ul style={{ listStyleType: 'none', lineHeight: 1.4, color: '#bb3e76' }}>
                                            {this.state.listIstoric.map((a, idx) => {

                                                if (idx < 5) {
                                                    return (
                                                        <li key={idx}>{a.an}.{new Utils().getMonths[a.luna - 1].luna}:{a.valoare} </li>
                                                    )
                                                }

                                            })}


                                        </ul>




                                    </Grid>
                                    <Grid style={{ width: '90%', border: '1px solid black' }} item xs={12} sm={12} md={6} lg={6} xl={6} >

                                        <h4 className='pm-title'>Previziune</h4>
                                        <span style={{ color: 'green' }}>{new Date().getFullYear()}.{new Utils().getMonths[new AnalizeClienti().addMonths(new Date(new Date().setMonth(this.state.listIstoric[0].luna - 1)), +1).getMonth()].luna}: {this.state.possibleOutcome} </span>

                                    </Grid>
                                </Grid>

                            }

                            {this.state.possibleOutcome === null &&
                                <h2 className='pm-title'>{this.dictionary.financiarContabil.nuExista}</h2>
                            }

                        </div>
                    </div>


                }

                {this.state.buttonSelectat === 'analiza_financiara' &&
                    <div className='container'>


                        <div style={{ marginTop: 30, marginBottom: 20, overflow: 'auto', width: '100%', }}>


                            <h2 className='pm-title'>{this.dictionary.financiarContabil.analizaUtilizatori}</h2>

                            <div style={{ border: '1px dashed gray' }}>
                                <span>Lunar</span>
                                <Switch
                                    className="pm-switch"
                                    checked={this.state.isLunar}
                                    onChange={(ev) => { this.lunarSapt(ev) }}
                                    value='companie'
                                /><span>Saptamanal</span>

                                <Table className='pm-indicatori-table'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                {this.dictionary.proiecte.etapeProiect.numeEtapa}
                                            </TableCell>

                                            <TableCell>
                                                {this.dictionary.proiecte.rapoarteProiect.totalOreCumulateTaskuri}
                                            </TableCell>

                                            <TableCell>
                                                {this.dictionary.proiecte.rapoarteProiect.totalOreDiferentaCompletare}
                                            </TableCell>
                                            <TableCell>
                                                {this.dictionary.proiecte.rapoarteProiect.totalOreAvansCompletare}
                                            </TableCell>
                                            <TableCell>
                                                {this.dictionary.proiecte.rapoarteProiect.pctDepasire}
                                            </TableCell>
                                            <TableCell>
                                                {this.dictionary.proiecte.rapoarteProiect.pctAvans}
                                            </TableCell>
                                            <TableCell>
                                                Expl
            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {this.state.listRaport.map((e, idx) => {
                                            return (
                                                <TableRow key={idx}>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                        {e.numeUser}
                                                    </TableCell>

                                                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                        {e.totalOreCumulateTaskuri}
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                        {!String(e.totalOreDiferentaCompletare).includes('-') &&
                                                            <span>{Math.abs(Number(e.totalOreDiferentaCompletare))}</span>
                                                        }
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                        {String(e.totalOreDiferentaCompletare).includes('-') &&
                                                            <span>{Math.abs(Number(e.totalOreDiferentaCompletare))}</span>
                                                        }
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                        {!String(e.pctDepasire).includes('-') &&
                                                            <span>{Math.abs(Number(e.pctDepasire))}</span>
                                                        }
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                        {String(e.pctDepasire).includes('-') &&
                                                            <span>{Math.abs(Number(e.pctDepasire))}</span>
                                                        }
                                                    </TableCell>
                                                    <TableCell >
                                                        {String(e.pctDepasire).includes('-') &&
                                                            <span style={{ color: 'green' }}>{this.dictionary.financiarContabil.utilizatorulTerminaTaskurileInainteDeTermen}{e.pctDepasire}%.</span>}
                                                        {!String(e.pctDepasire).includes('-') &&
                                                            <span style={{ color: 'pink' }}>{this.dictionary.financiarContabil.utilizatorulDepasesteTaskurile} {e.pctDepasire}%.</span>}
                                                    </TableCell>

                                                </TableRow>
                                            )
                                        })}


                                    </TableBody>
                                </Table>





                                <div className='chartDIv'>
                                    {this.state.chartData2 &&

                                        <HorizontalBar

                                            datasetKeyProvider={() => { return Math.random() }}
                                            // getElementAtEvent={(element)=>this.getLineData(element,i)}
                                            plugins={[ChartDataLabels]}

                                            data={{
                                                labels: this.state.chartData2.labels.map((r, idx) => { return (r) }),

                                                datasets: this.state.chartData2.chartData.map((r, idx) => {
                                                    return (
                                                        {
                                                            label: r.user,
                                                            backgroundColor: new Utils().culoriCharts(idx),
                                                            hoverBackgroundColor: new Utils().culoriCharts(idx),
                                                            data: r.chartData.map((r) => { return (Number(r.value.toFixed(2))) }),

                                                        }
                                                    )

                                                })




                                            }}

                                            options={{

                                                onClick: function (evt, elements) {

                                                    let selectedIndex = null
                                                    if (elements && elements.length) {
                                                        var segment = elements[0];
                                                        this.update();
                                                        if (selectedIndex !== segment["_index"]) {
                                                            selectedIndex = segment["_index"];
                                                            segment._model.outerRadius += 20;
                                                        }
                                                        else {
                                                            selectedIndex = null;
                                                        }
                                                    }
                                                },
                                                layout: {
                                                    padding: 60,
                                                    height: 300
                                                },

                                                plugins: {

                                                    datalabels: {
                                                        color: 'black',
                                                        formatter: (value, context) => {
                                                            //  console.log('value :', value);
                                                            //    console.log('context :', );
                                                            if (value > 0) {
                                                                return value
                                                            } else {
                                                                return ''
                                                            }


                                                        },
                                                        font: {
                                                            size: 13,
                                                            weight: 600
                                                        },
                                                        align: 'end',
                                                        clamp: true


                                                    },

                                                },
                                                legend: {
                                                    display: 'bottom'
                                                }
                                            }}

                                        />

                                    }
                                </div>
                            </div>
                        </div>



                        {/* <Chart
                        width={'100%'}
                        height={'500px'}
                        chartType='BarChart'

                        data={this.state.chartData2

                        }
                        options={{
                            title: 'Grafic General',

                        }}

                    /> */}
                    </div>

                }



                {this.state.buttonSelectat === 'analiza_financiara' &&

                    <div style={{ position: 'relative' }}>

                        <h2 className='pm-title'>{this.dictionary.financiarContabil.analizaProiecte}</h2>

                        {this.state.chartProiecte.map((cP, idx) => {
                            return (
                                <div style={{
                                    width: '45%', display: 'inline-block',
                                    position: 'relative',
                                    border: '1px dashed gray',
                                    marginRight: 20,
                                    marginTop: 30,
                                    verticalAlign: 'top'
                                }} key={idx}>
                                    <h3 className='pm-title'>{cP.titlu}</h3>
                                    <Bar

                                        datasetKeyProvider={() => { return Math.random() }}
                                        // getElementAtEvent={(element)=>this.getLineData(element,i)}
                                        plugins={[ChartDataLabels]}

                                        data={{
                                            labels: cP.labels.map((r, idx2) => { return (r) }),

                                            datasets:

                                                [
                                                    {
                                                        // label:r.user ,
                                                        backgroundColor: cP.labels.map((r, idx3) => { return (new Utils().culoriCharts(idx3)) }),
                                                        hoverBackgroundColor: cP.labels.map((r, idx3) => { return (new Utils().culoriCharts(idx3)) }),
                                                        data: cP.chartData.map((r) => { return (Number(r.toFixed(2))) }),

                                                    }
                                                ]





                                        }}

                                        options={{

                                            onClick: function (evt, elements) {

                                                let selectedIndex = null
                                                if (elements && elements.length) {
                                                    var segment = elements[0];
                                                    this.update();
                                                    if (selectedIndex !== segment["_index"]) {
                                                        selectedIndex = segment["_index"];
                                                        segment._model.outerRadius += 20;
                                                    }
                                                    else {
                                                        selectedIndex = null;
                                                    }
                                                }
                                            },
                                            layout: {
                                                padding: 60,
                                                height: 300
                                            },

                                            plugins: {

                                                datalabels: {
                                                    color: 'black',
                                                    formatter: (value, context) => {
                                                        // console.log('value :', value);
                                                        //    console.log('context :', );
                                                        if (value > 0) {
                                                            return value
                                                        } else {
                                                            return ''
                                                        }


                                                    },
                                                    font: {
                                                        size: 13,
                                                        weight: 600
                                                    },
                                                    align: 'end',
                                                    clamp: true


                                                },

                                            },
                                            legend: {
                                                display: false
                                            }
                                        }}

                                    />
                                </div>


                            )
                        })}

                        <FormControl className='inputFocus' style={{ width: '30%', margin: 'auto', marginTop: 20, marginBottom: 80 }}>
                            <InputLabel htmlFor="proiect">Selecteaza Proiect</InputLabel>
                            <Select

                                value={this.state.proiectId || ""}
                                onChange={this.changeProiecte}

                                input={<Input id="proiect" />}>


                                {this.state.chartProiecte.map((s, idx) => {
                                    return <MenuItem value={s.id} key={idx}  > {s.titlu}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>


                        <Divider className='pm-divider' />


                        {this.state.proiectId &&
                            <RapoarteProiect idproiect={this.state.proiectId}
                                onChangeEvent={c => this.changeProiect = c} />
                        }
                    </div>

                }



            </div >
        );
    }
}